/**
 * Breadcrumbs component overrides.
 * Clean breadcrumbs with subtle separator and hover colors.
 */

import type { Theme } from '@mui/material/styles';

const breadcrumbs: Theme['components'] = {
  MuiBreadcrumbs: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...theme.typography.body2,
      }),
      separator: {
        color: 'var(--mui-palette-text-disabled)',
        fontSize: '1rem',
        marginInline: 8,
      },
      li: {
        '& a': {
          color: 'var(--mui-palette-text-secondary)',
          textDecoration: 'none',
          transition: 'color 150ms ease',
          '&:hover': {
            color: 'var(--mui-palette-primary-main)',
          },
        },
        '& .MuiTypography-root': {
          fontSize: '0.8125rem',
        },
      },
    },
  },
};

export default breadcrumbs;
